import React from "react";

import { ReactComponent as WarningIcon } from "../assets/warningIcon.svg";
import {
  UnhitchWarningBodyStyled,
  UnhitchTextWarningStyled,
  UnhitchWarningIconStyled,
} from "../styles";

interface ValidationErrorProps {
  message: string;
}

export const ValidationError: React.FC<ValidationErrorProps> = ({
  message,
}) => (
  <UnhitchWarningBodyStyled>
    <UnhitchWarningIconStyled>
      <WarningIcon />
    </UnhitchWarningIconStyled>
    <UnhitchTextWarningStyled>{message}</UnhitchTextWarningStyled>
  </UnhitchWarningBodyStyled>
);
